// Vendor Libs
import React from 'react';

// Components
import CreateRule from '../app/create-rule';
import EditRule from '../app/edit-rule';
import FlexDashboard from '../core/flex-dashboard';
import Permissions from '../core/permissions';
import Rules from '../search-data/rules';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Rules',
                        component: Rules,
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Create Rule',
                        id: 'RULESCREATE',
                        component: CreateRule,
                    },
                    {
                        type: 'tab',
                        name: 'Edit Rule',
                        id: 'RULESEDIT',
                        component: EditRule,
                    },
                ],
            },
        ],
    },
};

function DashboardRules() {
    return (
        <Permissions adminOnly={true} autoRedirect={true}>
            <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="rules" />
        </Permissions>
    );
}

export default DashboardRules;
